'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walletCanSend = exports.isMissingWeb3 = exports.isLocked = exports.isNotProvided = exports.isLoading = exports.isInteractive = undefined;

var _walletTypes = require('../utilities/walletTypes');

var isInteractive = exports.isInteractive = function isInteractive(state) {
  var walletType = state.account.walletType;

  if (!walletType) {
    return null;
  }
  var walletDefinition = _walletTypes.walletDefinitions.find(function (def) {
    return def.type === walletType;
  });
  var result = walletDefinition.isInteractive;

  return result;
};

var isLoading = exports.isLoading = function isLoading(state) {
  var automatic = isInteractive(state);
  var _state$account = state.account,
      walletType = _state$account.walletType,
      network = _state$account.network,
      web3Provided = _state$account.web3Provided,
      web3Locked = _state$account.web3Locked,
      address = _state$account.address,
      balance = _state$account.balance;

  // prompt user for wallet

  if (!walletType) {
    return false;
  }

  if (!network) {
    return true;
  }

  if (automatic) {
    if (web3Provided === null) {
      return true;
    }
    if (web3Provided === false) {
      return false;
    }
    if (web3Locked) {
      return false;
    }
  }

  if (address) {
    if (!balance) {
      return true;
    }
    return false;
  }

  // waiting for stuffs still
  return true;
};

var isNotProvided = exports.isNotProvided = function isNotProvided(state) {
  return isInteractive(state) && state.account.web3Provided === false;
};

var isLocked = exports.isLocked = function isLocked(state) {
  return isInteractive(state) && state.account.web3Provided && !state.account.address;
};

var isMissingWeb3 = exports.isMissingWeb3 = function isMissingWeb3(state) {
  return state.account.walletType === 'browser' && state.account.web3Provided === false;
};

var walletCanSend = exports.walletCanSend = function walletCanSend(state) {
  return state.account.walletType === 'browser' || state.account.walletType === 'ledger';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/selectors/account.js
// module id = 1290
// module chunks = 0